module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sky-scheme"
  }, [_c('table', [(_vm.thead) ? _c('thead', _vm._l((_vm.thead), function(row, index) {
    return _c('tr', {
      key: index
    }, _vm._l((row), function(cell, index) {
      return _c('th', {
        key: index,
        class: [{
          'side-header': _vm.hasSideHeader && index === 0
        }, {
          'highlighted': cell.setting
        }],
        style: (_vm.styleObject(cell.setting))
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.convertLineBreaks(cell.value))
        }
      })])
    }))
  })) : _vm._e(), _vm._v(" "), (_vm.tbody) ? _c('tbody', _vm._l((_vm.tbody), function(row, index) {
    return _c('tr', {
      key: index
    }, _vm._l((row), function(cell, index) {
      return _c('td', {
        key: index,
        class: [{
          'side-header': _vm.hasSideHeader && index === 0
        }, {
          'highlighted': cell.setting
        }],
        style: (_vm.styleObject(cell.setting))
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.convertLineBreaks(cell.value))
        }
      })])
    }))
  })) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "sky-accordions"
  }, _vm._l((_vm.accordion), function(acc, index) {
    return _c('sky-accordion', {
      key: index
    }, [_c('span', {
      attrs: {
        "slot": "title"
      },
      domProps: {
        "textContent": _vm._s(acc.topheader)
      },
      slot: "title"
    }), _vm._v(" "), _c('ul', _vm._l((acc.items), function(line, index) {
      return _c('li', {
        key: index,
        class: {
          'highlighted': line.setting
        },
        style: (_vm.styleObject(line.setting))
      }, [(line.sideheader) ? _c('span', {
        staticClass: "title",
        domProps: {
          "innerHTML": _vm._s(_vm.convertLineBreaks(line.sideheader))
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "text",
        domProps: {
          "innerHTML": _vm._s(_vm.convertLineBreaks(line.content))
        }
      })])
    }))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-29fc8c70"}!./scripts/sky-scheme/sky-scheme.html
// module id = 345
// module chunks = 1